export const baseUrl = "https://mf.amanmicrofinance.com/api";
export const altsapiBaseUrl = "https://altsapi.amanmfapp.com/Uniparticle/api";
export const stageBaseUrl = "https://stage.amanmicrofinance.com/api";
